// extracted by mini-css-extract-plugin
export var careNumbersContainer = "care-numbers-module--careNumbersContainer--ed815";
export var content = "care-numbers-module--content--8554a";
export var label = "care-numbers-module--label--7d717";
export var numberBlock = "care-numbers-module--numberBlock--55195";
export var numbersContainer = "care-numbers-module--numbersContainer--54a73";
export var title = "care-numbers-module--title--4c199";
export var value = "care-numbers-module--value--669f7";